import moment from 'moment';
import React from 'react';
import { greenTick, popup_close } from '../../assets/images';

const AppointmentBookedModal = ({ packageName = '', provider = '', employeeName = '', date = '', time = '', uniqueID ='', handleClose }) => {
  return (
    <div className='flex-col flex h-full' style={{ background: '#F5F7F9' }}>
      <div className='flex flex-col py-4 px-6 text-white' style={{ backgroundColor: '#00A04F'}}>
        <div className='flex justify-end'>
          <img src={ popup_close } alt='close-icon' onClick={ handleClose } className='h-7 cursor-pointer'/>
        </div>
        <div className='flex items-center justify-start'>
          <div className='text-xl font-semibold my-1' style={{ fontWeight: '800'}}>Appointment booked</div>
          <img src={ greenTick } alt='close-icon' onClick={ handleClose } className='h-5 mx-2 cursor-pointer'/>
        </div>
        <div className='text-sm leading-4 my-1'>Employee will receive confirmation email shortly</div>
      </div>
      <div className='text-xs font-semibold tracking-widest leading-3 text-gray-500 mt-6 px-6'>CENTER DETAILS</div>
      <div className='flex flex-col bg-white py-4 px-6 my-2 border border-gray-200'>
        <div className='font-semibold text-base text-gray-800'>{`${provider.enterprise_name}, ${provider.city}`}</div>
        <div className='text-sm text-gray-500 font-semibold'>{provider.address}</div>
      </div>
      <div className='text-xs font-semibold tracking-widest leading-3 text-gray-500 mt-4 px-6'>APPOINTMENT DETAILS</div>
      <div className='bg-white my-2'>
        <div className='border-gray-200 py-4 px-6 border flex flex-col'>
          <div className='text-sm font-semibold tracking-wide leading-4 text-gray-500'>PACKAGE NAME</div>
          <div className='text-sm text-gray-600 font-semibold '>{packageName}</div>
        </div>
        <div className='border-gray-200 py-4 px-6 border-b flex justify-between'>
          <div className='text-sm font-semibold tracking-wide leading-4 text-gray-500'>DATE & TIME</div>
          <div className='text-sm text-gray-600 font-semibold '>{time}</div>
        </div>
        <div className='border-gray-200 py-4 px-6 border-b flex justify-between'>
          <div className='text-sm font-semibold tracking-wide leading-4 text-gray-500'>BOOKED FOR</div>
          <div className='text-sm text-gray-600 font-semibold '>{employeeName}</div>
        </div>
        <div className='border-gray-200 py-4 px-6 border-b flex justify-between'>
          <div className='text-sm font-semibold tracking-wide leading-4 text-gray-500'>APPOINTMENT ID</div>
          <div className='text-sm text-gray-600 font-semibold '>{uniqueID}</div>
        </div>
      </div>
    </div>
  )

}

export default AppointmentBookedModal;